import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { hasLessonForNode } from "@music-app/lessons/runtime";

/**
 * Renders a "Read the lesson →" link to the first authored lesson among
 * `nodeIds`. Invisible when no lesson exists for any of the provided nodes.
 * Used in drill config screens to close the drill↔learn loop (R27).
 */
export function ExerciseLessonLink({ nodeIds }: { nodeIds: readonly string[] }): ReactNode {
  const nodeId = nodeIds.find(hasLessonForNode);
  if (!nodeId) return null;
  return (
    <Link
      to={`/learn/${nodeId}`}
      className="font-mono text-[10px] uppercase tracking-widest text-inkFaded hover:text-accent transition-colors mt-3 block"
    >
      Read the lesson →
    </Link>
  );
}
